import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROUTES } from 'src/app/constants';
import { LoginComponent } from './login.component';

const routes: Routes = [
	{ path: ROUTES.ROOT, component: LoginComponent }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})

export class LoginRoutingModule { }
